import { Component, OnInit, DestroyRef } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { AccountService } from "app/shared/services/account.service";
import { environment } from "environments/environment";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-choose-adventure",
  templateUrl: "./choose-adventure.component.html",
  styleUrls: ["./choose-adventure.component.scss"],
  standalone: false,
})
export class ChooseAdventureComponent implements OnInit {
  public roles;
  public isUser;
  public isEnterprise;
  public enterpriseURL;
  public memberPortalURL;

  constructor(
    private accountService: AccountService,
    private titleService: Title,
    private translate: TranslateService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.translate
      .stream("MFA.PAGE_TITLE")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((pageTitle) => {
        this.titleService.setTitle(pageTitle);
      });
    this.roles = this.accountService.getRoles();
    this.isUser = this.roles.includes("$user");
    this.isEnterprise = this.roles.some((role) => role === "$enterprise");

    if (this.isEnterprise) {
      this.enterpriseURL = `${environment.ENTERPRISE_URL}/`;
    }
    this.memberPortalURL = this.accountService.getHomeUrl();
  }

  navigateTo(portal) {
    window.location.href = this[portal];
  }
}
